import * as Types from '../../../../gql/types.generated';

import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RootUserPermissionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RootUserPermissionsQuery = { __typename?: 'Query', me: { __typename?: 'MeInfo', permissionsNew: any } };


export const RootUserPermissionsDocument = gql`
    query rootUserPermissions {
  me {
    permissionsNew
  }
}
    `;

/**
 * __useRootUserPermissionsQuery__
 *
 * To run a query within a React component, call `useRootUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootUserPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRootUserPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<RootUserPermissionsQuery, RootUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RootUserPermissionsQuery, RootUserPermissionsQueryVariables>(RootUserPermissionsDocument, options);
      }
export function useRootUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RootUserPermissionsQuery, RootUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RootUserPermissionsQuery, RootUserPermissionsQueryVariables>(RootUserPermissionsDocument, options);
        }
export type RootUserPermissionsQueryHookResult = ReturnType<typeof useRootUserPermissionsQuery>;
export type RootUserPermissionsLazyQueryHookResult = ReturnType<typeof useRootUserPermissionsLazyQuery>;
export type RootUserPermissionsQueryResult = Apollo.QueryResult<RootUserPermissionsQuery, RootUserPermissionsQueryVariables>;


export function useRootUserPermissionsRequest() {
    const client = useApolloClient();
    return useCallback<(variables: RootUserPermissionsQueryVariables, options?: Omit<Apollo.QueryOptions, 'query'>) => Promise<Apollo.ApolloQueryResult<RootUserPermissionsQuery>>>( (variables, options) => {
        return client.query<RootUserPermissionsQuery>({
            fetchPolicy: 'no-cache',
          ...options,
          query: RootUserPermissionsDocument,
          variables
        })
    }, []);
}

